import { ewent } from "../../lib/reactive";
import lodash from "lodash";
import { Process } from "../../lib/Process";
import { util } from "../../lib/util/util";
import { FakeLodash } from "../../lib/coreutil/FakeLodash";
export var Sliders;
(function (Sliders) {
    let SliderPuzzle;
    (function (SliderPuzzle) {
        function getState(puzzle) {
            return puzzle.tiles.map(t => t.position);
        }
        SliderPuzzle.getState = getState;
    })(SliderPuzzle = Sliders.SliderPuzzle || (Sliders.SliderPuzzle = {}));
    let SliderState;
    (function (SliderState) {
        SliderState.BLANK_TILE = 24;
        SliderState.SOLVED = [
            0, 1, 2, 3, 4,
            5, 6, 7, 8, 9,
            10, 11, 12, 13, 14,
            15, 16, 17, 18, 19,
            20, 21, 22, 23, 24
        ];
        function equals(a, b) {
            for (let i = 0; i < a.length; i++) {
                if (a[i] != b[i])
                    return false;
            }
            return true;
        }
        SliderState.equals = equals;
        function withMove(state, ...moves) {
            const copy = [...state];
            moves.forEach(move => {
                const split_moves = Move.split(move);
                let blank = copy.indexOf(24);
                for (let move of split_moves) {
                    copy[blank] = copy[blank + move];
                    blank += move;
                }
                copy[blank] = 24;
            });
            return copy;
        }
        SliderState.withMove = withMove;
        function blank(state) {
            return state.indexOf(SliderState.BLANK_TILE);
        }
        SliderState.blank = blank;
        function findMove(before, after) {
            const blank_before = blank(before);
            const blank_after = blank(after);
            const move = blank_after - blank_before;
            if (!Move.isValid(move))
                return null;
            if (!SliderState.equals(after, SliderState.withMove(before, move)))
                return null;
            return move;
        }
        SliderState.findMove = findMove;
        function neighbours(state, multitile_allowed = true) {
            const open_tile = blank(state);
            const x = open_tile % 5;
            const y = Math.floor(open_tile / 5);
            let moves = [];
            for (let xi = 0; xi < 5; xi++) {
                if (xi != x)
                    moves.push(xi - x);
            }
            for (let yi = 0; yi < 5; yi++) {
                if (yi != y)
                    moves.push((yi - y) * 5);
            }
            if (!multitile_allowed)
                moves = moves.filter(Move.isSmallStep);
            return moves.map(m => SliderState.withMove(state, m));
        }
        SliderState.neighbours = neighbours;
        function manhatten(a, b) {
            return Math.abs(a % 5 - b % 5)
                + Math.abs(Math.floor(a / 5) - Math.floor(b / 5));
        }
        function sumManhattenDistance(state) {
            return FakeLodash.sumBy(state, (target, position) => target == 24 ? 0 :
                Math.abs(target % 5 - position % 5)
                    + Math.abs(Math.floor(target / 5) - Math.floor(position / 5)));
        }
        SliderState.sumManhattenDistance = sumManhattenDistance;
        function permutation_parity(state) {
            const visited = new Array(state.length).fill(false);
            let odd_cycles = 0;
            let even_cycles = 0;
            while (true) {
                const next = visited.indexOf(false);
                if (next < 0)
                    break;
                let cycle_length = 0;
                let i = state[next];
                while (!visited[i]) {
                    visited[i] = true;
                    i = state[i];
                    cycle_length++;
                }
                if (cycle_length % 2 == 0)
                    even_cycles++;
                else
                    odd_cycles++;
            }
            return even_cycles % 2;
        }
        SliderState.permutation_parity = permutation_parity;
        function isSolveable(state) {
            return permutation_parity(state.filter(i => i != 24)) % 2 == 0;
        }
        SliderState.isSolveable = isSolveable;
        function createRandom() {
            let state = null;
            do {
                state = [...lodash.shuffle(SliderState.SOLVED.slice(0, 24)), 24];
            } while (!isSolveable(state));
            return state;
        }
        SliderState.createRandom = createRandom;
        function toString(state) {
            return [0, 1, 2, 3, 4].map(row => state.slice(row * 5, (row + 1) * 5)
                .map(t => ("  " + t.toString()).slice(-2)).join(", ")).join("\n");
        }
        SliderState.toString = toString;
    })(SliderState = Sliders.SliderState || (Sliders.SliderState = {}));
    let SlideStateWithBlank;
    (function (SlideStateWithBlank) {
        function fromState(state) {
            return { tiles: state, blank: SliderState.blank(state) };
        }
        SlideStateWithBlank.fromState = fromState;
        function doMove(state, move) {
            const index = state.blank + move;
            // TODO: This does not account for multi tile moves
            state.tiles[state.blank] = state.tiles[index];
            state.tiles[index] = SliderState.BLANK_TILE;
        }
        SlideStateWithBlank.doMove = doMove;
        function copy(state) {
            return FakeLodash.cloneDeep(state);
        }
        SlideStateWithBlank.copy = copy;
    })(SlideStateWithBlank = Sliders.SlideStateWithBlank || (Sliders.SlideStateWithBlank = {}));
    let Move;
    (function (Move) {
        Move.all = [-20, -15, -10, -5, -4, -3, -2, -1, 1, 2, 3, 4, 5, 10, 15, 20];
        Move.singletile_moves = [-5, -1, 1, 5];
        Move.multitile_moves = Move.all;
        Move.horizontal_mtm = [-4, -3, -2, -1, 1, 2, 3, 4];
        Move.vertical_mtm = [-20, -15, -10, -5, 5, 10, 15, 20];
        function split(move) {
            const single_tile_move = Math.sign(move) * (Math.abs(move) >= 5 ? 5 : 1);
            const n = move / single_tile_move;
            return new Array(n).fill(single_tile_move);
        }
        Move.split = split;
        function isSmallStep(move) {
            return [1, -1, 5, -5].includes(move);
        }
        Move.isSmallStep = isSmallStep;
        function isValid(move) {
            return [1, 2, 3, 4, 5, 10, 15, 20].includes(Math.abs(move));
        }
        Move.isValid = isValid;
        function isVertical(move) {
            return move % 5 == 0;
        }
        Move.isVertical = isVertical;
    })(Move = Sliders.Move || (Sliders.Move = {}));
    let MoveList;
    (function (MoveList) {
        var index = util.index;
        var isVertical = Sliders.Move.isVertical;
        function combine(first, second, multitile) {
            while (second.length > 0 && first.length > 0) {
                const needs_fixing = multitile
                    ? Sliders.Move.isVertical(second[0]) == Sliders.Move.isVertical(index(first, -1))
                    : second[0] == -index(first, -1);
                if (!needs_fixing)
                    break;
                second[0] += index(first, -1);
                first.splice(first.length - 1);
                if (second[0] == 0)
                    second.splice(0, 1);
            }
            const res = [...first, ...second];
            return res;
        }
        MoveList.combine = combine;
        function annotate(state, moves, prestates_multitile_allowed = true) {
            if (!moves)
                debugger;
            const buffer = [];
            for (let move of moves) {
                state = SliderState.withMove(state, move);
                buffer.push({
                    pre_states: SliderState.neighbours(state, prestates_multitile_allowed),
                    post_state: state,
                    move: move,
                    clicked_tile: SliderState.blank(state)
                });
            }
            return buffer;
        }
        MoveList.annotate = annotate;
        /**
         * Compressed a list of single tile moves into a list of multitile moves.
         * @param moves
         */
        function compress(moves) {
            let i = 0;
            const combined_moves = [];
            while (i < moves.length) {
                let move = moves[i];
                i++;
                while (i < moves.length) {
                    if (isVertical(moves[i]) != isVertical(move))
                        break;
                    move += moves[i];
                    i++;
                }
                if (move != 0)
                    combined_moves.push(move);
            }
            return combined_moves;
        }
        MoveList.compress = compress;
        function expand(moves) {
            return moves.flatMap(Move.split);
        }
        MoveList.expand = expand;
        function fromTileList(tiles, blank) {
            const moves = [];
            for (let tile of tiles) {
                moves.push(tile - blank);
                blank = tile;
            }
            return moves;
        }
        MoveList.fromTileList = fromTileList;
    })(MoveList = Sliders.MoveList || (Sliders.MoveList = {}));
    class Solver {
    }
    Sliders.Solver = Solver;
    /**
     * Abstract base class for solving processes for slider puzzles.
     * SlideSolvers are single-use for a specific starting state.
     */
    class SolvingProcess extends Process {
        constructor(start_state) {
            super();
            this.start_state = start_state;
            this.update_event = ewent();
            this.better_solution_found = ewent();
            this.best_solution = null;
            this.use_first_solution = false;
            this.compress_moves = false;
            this.native_compression = false;
            this.withInterrupt(50, 1)
                .onInterrupt(() => this.updateProgress());
        }
        setCombineStraights(value = true) {
            this.compress_moves = value;
            return this;
        }
        registerSolution(moves) {
            if (this.native_compression != this.compress_moves) {
                if (this.compress_moves)
                    moves = MoveList.compress(moves);
                else
                    moves = MoveList.expand(moves);
            }
            if (!this.best_solution || moves.length < this.best_solution.length) {
                this.best_solution = moves;
                this.better_solution_found.trigger(moves);
                if (this.use_first_solution)
                    throw new SolvingProcess.SolutionFoundException();
            }
            return this;
        }
        updateProgress() {
            this.progress = (Date.now() - this.start_time) / (this.end_time - this.start_time);
            this.update_event.trigger(this);
        }
        async implementation() {
            try {
                await this.solve_implementation();
            }
            catch (e) { }
            return this.getBest();
        }
        onUpdate(f) {
            this.update_event.on(f);
            return this;
        }
        onFound(f) {
            this.better_solution_found.on(f);
            return this;
        }
        getProgress() {
            return this.progress;
        }
        getBest() {
            return this.best_solution;
        }
        useFirstSolution() {
            this.use_first_solution = true;
            return this;
        }
    }
    Sliders.SolvingProcess = SolvingProcess;
    (function (SolvingProcess) {
        class SolutionFoundException extends Error {
            constructor() { super(); }
        }
        SolvingProcess.SolutionFoundException = SolutionFoundException;
    })(SolvingProcess = Sliders.SolvingProcess || (Sliders.SolvingProcess = {}));
})(Sliders || (Sliders = {}));
